import ltrim from '../../../utils/strings/ltrim';
export var parseMarkdown = function parseMarkdown(markdownText) {
  if (!markdownText) {
    return;
  }

  var body = '';
  var parts = markdownText.split('\n');
  var list = '';
  var inList = false;
  parts.forEach(function (line) {
    if (line.indexOf('- ') === 0) {
      inList = true;
      list += "<li>".concat(ltrim(line, ['-', ' ']), "</li>");
    } else if (inList) {
      inList = false;
      body += "<ul>".concat(list, "</ul>");
      list = '';
    } else if (line !== '') {
      body += "".concat(line, "<br>");
    }
  });

  if (inList) {
    body += "<ul>".concat(list, "</ul>");
  }

  return body;
};